import { ReactComponent as ChevronRightIcon } from 'assets/icons/chevron_right.svg';
import React from 'react';

import { BreadcrumbContainer, BreadcrumbItem, BreadcrumbLink } from './Breadcrumb.styles';

export interface IBreadcrumb {
  title: string;
  link: string;
  active: boolean;
  handler?: () => void;
}
type BreadcrumbProps = {
  breadcrumbs: IBreadcrumb[];
};
const Breadcrumb = ({ breadcrumbs }: BreadcrumbProps) => {
  const handleItemClick = (e: React.MouseEvent, breadcrumb: IBreadcrumb) => {
    if (breadcrumb.handler === undefined) return;

    e.preventDefault();
    breadcrumb.handler();
  };

  return (
    <BreadcrumbContainer>
      {breadcrumbs.map((breadcrumb: IBreadcrumb, idx: number) => (
        <React.Fragment key={idx}>
          <BreadcrumbItem>
            {breadcrumb.active ? (
              breadcrumb.title
            ) : (
              <BreadcrumbLink
                to={breadcrumb.link}
                onClick={(e: React.MouseEvent) => {
                  handleItemClick(e, breadcrumb);
                }}
              >
                {breadcrumb.title}
              </BreadcrumbLink>
            )}
          </BreadcrumbItem>

          {breadcrumbs.length - 1 > idx && (
            <BreadcrumbItem>
              <ChevronRightIcon />
            </BreadcrumbItem>
          )}
        </React.Fragment>
      ))}
    </BreadcrumbContainer>
  );
};

export default Breadcrumb;
